import { styled, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const KlasisDatePickerBase = styled(DatePicker)(() => ({
    '&': {
        width: '12rem'
    }
})) as typeof DatePicker;

interface IKlasisDatePickerProps<TValue> {
    value: TValue | null;
    label?: string;
    onChange: (value: TValue | null, keyboardInputValue?: string) => void;
}

function KlasisDatePicker<TValue>(props: IKlasisDatePickerProps<TValue>): JSX.Element {
    return (
        // TODO E.K. localization [adapterLocale] and dynamic dayjs/locale/%lng% import
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <KlasisDatePickerBase
                value={props.value}
                onChange={(newValue) => {props.onChange(newValue)}}
                renderInput={(params) => (
                    <TextField 
                        size="small" 
                        {...params} 
                        inputProps={{
                            ...params.inputProps,
                            placeholder: props.label
                        }} />
                )}
            />
        </LocalizationProvider>
    )
}

export default KlasisDatePicker;